import React, {Component} from "react";
//import Footer from "./Footer";
import axios from "axios";

const api = axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}/adminuser/categoriesAPI/`
})
class Categories extends Component{

    
    constructor(props) {
        super(props);
        this.state = {
            category : [],
            id:'',
            name:'',
            description:'',
            image:null,
            img_update:'no',
        }
        this.getCategories();
    }
    
    handleName = (e) => {
        this.setState({name:e.target.value})
    }
    handleDescription = (e) => {
        this.setState({description:e.target.value})
    }
    handleImage = (e) => {
        this.setState({image:e.target.files[0]})
    }
    getCategories = async () => {
        if (localStorage.getItem('access')) {
            //const token = localStorage.getItem('access');
            let data = await api.get('/').then(({data})=>data);
            this.setState({category:data})
           }
    }
        //let data = await api.get('/').then(({data})=>data);
        //this.setState({category:data})

    addCategory =async () => {
        let data = new FormData();
        const token = localStorage.getItem('access');
        data.append('name', this.state.name);
        data.append('description', this.state.description);
        data.append('image_url', this.state.image,this.state.image.name);
        await api.post('/create/',data,{ headers: { Authorization: `Bearer ${token}` } })
        this.getCategories();
    }

    delCategory = async (id) => {
        const token = localStorage.getItem('access');
        await api.delete(`/${id}/`,{ headers: { Authorization: `Bearer ${token}` } })
        this.getCategories();
    }
    
    updateStates = (id,n,d,img) => {
        this.setState({ id:id, name: n ,description: d,image:img ,img_update:'no'});
    }
    delStates = () => {
        this.setState({ name: '',description:'',image_url:'' });
    }
    img = () => {
        this.setState({ img_update:'yes'});
    }
    updateCategory = async () => {
        let data = new FormData();
        const token = localStorage.getItem('access');
        data.append('name', this.state.name);
        data.append('description', this.state.description);
        await api.put(`/${this.state.id}/`, data,{ headers: { Authorization: `Bearer ${token}` } })
        this.getCategories();
    }
    updateCategoryWithImag = async () => {
        const token = localStorage.getItem('access');
        let data = new FormData();
        data.append('name', this.state.name);
        data.append('description', this.state.description);
        data.append('image_url', this.state.image,this.state.image.name);
        await api.put(`/${this.state.id}/`, data,{ headers: { Authorization: `Bearer ${token}` } })
        this.getCategories();
    }
    
    
    render() {
        return(
            <>
            <br/><br/>
            <div className='ms-5 me-5  mt-5'>
            <h1 style={{display: 'inline'}}><b>Categories</b></h1>
            <button type="button" className="btn btn-primary float-end" data-bs-toggle="modal" data-bs-target="#AddCategory" onClick={this.delStates} style={{fontSize:'18px'}}><i className="fa fa-plus-circle" ></i> <b>Add New</b></button>
                <table className="table table-striped table-bordered mt-2">
                <thead>
                    <tr className="table-dark">
                        <th scope="col">Name</th>
                        <th scope="col">Description</th>
                        <th scope="col" className="text-center">Image</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>
                <tbody>
                {this.state.category.map(a =>
                <tr key={a.id}>
                    <td width="20%">{a.name}</td> 
                    <td width="40%">{a.description}</td> 
                    <td className="text-center"><img src={`${a.image_url}`} style={{height: '70px' , width: '90px'}} alt="..." /></td>
                    <td width="15%"><button title='Delete Category' style={{border: 'none',backgroundColor: 'transparent'}} onClick={() => this.delCategory(a.id)}> <i className='fa fa-trash' style={{fontSize:'24px', color:'red'}}></i> </button><span>  </span>
                    <button title='Edit Category' style={{border: 'none',backgroundColor: 'transparent'}} data-bs-toggle="modal" data-bs-target="#updateCategory" onClick={() => this.updateStates(a.id,a.name,a.description,a.image_url)}> <i className='fa fa-edit' style={{fontSize:'24px', color: '#0275d8'}}></i> </button></td>           
                </tr>
                )}
                </tbody>
                </table>
            </div>
           
            <div className="modal fade" id="AddCategory" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Add Category</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <form>
                    <div className="mb-3">
                        <label className="col-form-label">Name:</label>
                        <input type="text" className="form-control" name="name" onChange={this.handleName} value={this.state.name}/>
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Image Url:</label>
                        <input type="file" className="form-control" name="image_url" onChange={this.handleImage}/>
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Description:</label>
                        <textarea className="form-control" name="description" onChange={this.handleDescription} value={this.state.description}/>
                    </div>
                    
                    </form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="reset" className="btn btn-primary" onClick={this.addCategory} data-bs-dismiss="modal">Submit</button>
                </div>
                </div>
            </div>
            </div>


             {/* form for Update */} 

            <div className="modal fade" id="updateCategory" tabIndex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
            <div className="modal-dialog">
                <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">Update Category</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body">
                    <form>
                    <div className="mb-3">
                        <label className="col-form-label">Name:</label>
                        <input type="text" className="form-control" name="name" onChange={this.handleName} value={this.state.name}/>
                    </div>
                    { (this.state.img_update === 'no') ?
                    <div className="mb-3">
                        <label className="col-form-label">Image :</label><br/>
                        <div className='container' style={{position: 'relative',height: '80px' , width: '90px'}}>
                            <img src={`${this.state.image}`} alt="..."  style={{height: '90px' , width: '100px'}} /><br/>
                            <button onClick={this.img} style={{position: 'absolute',top: '0%',left: '90%',backgroundColor:'transparent', backgroundRepeat:'no-repeat',border: 'none',cursor:'pointer',overflow: 'hidden',outline:'none'}}>
                            <i className='fa fa-window-close' style={{fontSize:'24px',color:'white'}}></i></button>
                        </div>
                    </div>
                    :
                    <div className="mb-3">
                        <label className="col-form-label">Image Url:</label>
                        <input type="file" className="form-control" name="image_url" onChange={this.handleImage}/>
                    </div>
                    }
                    <div className="mb-3">
                        <label className="col-form-label">Description:</label>
                        <textarea className="form-control" name="description" onChange={this.handleDescription} value={this.state.description}/>
                    </div>
                    
                    </form>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    { (this.state.img_update === 'no') ?
                        <button type="reset" className="btn btn-primary"  data-bs-dismiss="modal" onClick={this.updateCategory}>Submit</button>
                        :
                        <button type="reset" className="btn btn-primary"  data-bs-dismiss="modal" onClick={this.updateCategoryWithImag}>Submit</button>
                    }
                </div>
                </div>
            </div>
            </div>
                
            </>
        )
    }
} 
export default Categories;